import { mdiChevronDown } from '@mdi/js';
import { Icon } from '@mdi/react';
import Tooltip from '@root/src/components/Tooltip';

import { controlClasses } from '../../classes';
import { TooltipIcon } from '../TooltipIcon';

import { controlRowIconBackgroundClasses } from './classes';

interface ControlRowOptionParentProps {
  icon: string;
  title: string;
  isDisabled?: boolean;
  onClick?: () => void;
  isOpen?: boolean;
  indicatorColor?: string | null;
  suppressActiveStyle?: boolean;
}

export const ControlRowOptionParent = ({
  isDisabled = false,
  title,
  onClick,
  isOpen,
  icon,
  indicatorColor,
  suppressActiveStyle = false,
}: ControlRowOptionParentProps) => {
  return (
    <div className="flex content-center">
      <div className={controlRowIconBackgroundClasses({ isOpen })}>&nbsp;</div>
      <Tooltip content={title}>
        <button
          onClick={onClick}
          disabled={isDisabled}
          className={controlClasses({
            isActive: !suppressActiveStyle && isOpen,
            isDisabled,
            hasDropdown: true,
          })}
        >
          <span className="relative inline-flex items-center">
            <TooltipIcon icon={icon} />
            {indicatorColor ? (
              <span
                aria-hidden="true"
                data-testid="control-row-option-indicator"
                className="pointer-events-none absolute -bottom-2 left-1/2 block h-1 w-4 -translate-x-1/2 rounded-sm"
                style={{ backgroundColor: indicatorColor }}
              />
            ) : null}
          </span>
          <Icon path={mdiChevronDown} size={'18px'} className="-mx-1 -my-1" />
        </button>
      </Tooltip>
    </div>
  );
};
